import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { Icon20 } from 'builder/components/Icon'
import ModalOverlay from 'builder/components/ModalOverlay'

import { MappedProgressData } from '../types'
import { ModalSection } from './ModalSection'
import * as Styles from './styles'
import { MobileModal } from './MobileModal'
const TRANSLATIONS = 'builder.dashboard.progress_tracker.modal'

type ProgressModalProps = {
  progressData?: MappedProgressData
  onClose: () => void
  isOpen: boolean
}

export const ProgressModal = ({ progressData, onClose, isOpen }: ProgressModalProps) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  if (isPhone) {
    return <MobileModal progressData={progressData} onClose={onClose} isOpen={isOpen} />
  }

  if (!isOpen) return null

  return (
    <ModalOverlay
      isOpen={isOpen}
      overlayFadeDuration={300}
      contentSlideDuration={300}
      onClick={onClose}
      fullScreen={false}
    >
      <Styles.ModalContainer>
        <Styles.ModalCloseButton onClick={onClose}>
          <Icon20.Close />
        </Styles.ModalCloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader>
            <Styles.ModalTitle>{i18n.t(`${TRANSLATIONS}.title`)}</Styles.ModalTitle>
          </Styles.ModalHeader>
          <Styles.ModalBody>
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.resumes`)}
              services={progressData?.resumes}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.jobs`)}
              services={progressData?.jobs}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.interviews`)}
              services={progressData?.interview}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.careers`)}
              services={progressData?.learning}
            />
          </Styles.ModalBody>
        </Styles.ModalContent>
      </Styles.ModalContainer>
    </ModalOverlay>
  )
}
